import {Routes} from '@angular/router';
import {AuthGuard} from '../../core/guards/auth.guard';

export const citizenRouteNames = {
  index: "",
  auth: 'auth',
  register: 'register',
  resetPassword: "reset-password",
  trackComplaint: "track-complaint",
  viewComplaint: 'complaint/:id',
  settings: "settings/profile",
  complaints: "complaints",
}

export const citizenRoutes: Routes = [
  {
    path: citizenRouteNames.index,
    loadComponent: () => import("./citizen-landing/citizen-landing.component").then(({CitizenLandingComponent}) => CitizenLandingComponent),
    data: { title: 'Mbaza | Home' }
  },
  {
    path: citizenRouteNames.auth,
    loadComponent: () => import("./citizen-auth/citizen-auth.component").then(({CitizenAuthComponent}) => CitizenAuthComponent),
    data: { title: 'Mbaza | Login' }
  },
  {
    path: citizenRouteNames.register,
    loadComponent: () => import("./citizen-register/citizen-register.component").then(({CitizenRegisterComponent}) => CitizenRegisterComponent),
    data: { title: 'Mbaza | Register' }
  },
  {
    path: citizenRouteNames.resetPassword,
    loadComponent: () => import("./citizen-reset-password/citizen-reset-password.component").then(({CitizenResetPasswordComponent}) => CitizenResetPasswordComponent),
    data: { title: 'Mbaza | Reset password' }
  },
  {
    path: citizenRouteNames.trackComplaint,
    loadComponent: () => import("./citizen-track-complaint/citizen-track-complaint.component").then(({CitizenTrackComplaintComponent}) => CitizenTrackComplaintComponent),
    data: { title: 'Mbaza | Track complaint' }
  },
  {
    path: citizenRouteNames.viewComplaint,
    loadComponent: () => import("./complaint-detail/complaint-detail.component").then(({ComplaintDetailComponent}) => ComplaintDetailComponent),
    canActivate: [AuthGuard],
    data: { title: 'Mbaza | View complaint' }
  },
  {
    path: citizenRouteNames.settings,
    loadComponent: () => import("./citizen-settings/citizen-settings.component").then(({CitizenSettingsComponent}) => CitizenSettingsComponent),
    canActivate: [AuthGuard],
    data: { title: 'Mbaza | User settings' }
  },
  {
    path: citizenRouteNames.complaints,
    loadComponent: () => import("./citizen-dashboard/citizen-dashboard.component").then(({CitizenDashboardComponent}) => CitizenDashboardComponent),
    canActivate: [AuthGuard],
    data: { title: 'Mbaza | My complaints' }
  },
]
